// config/AppVersion.js
export const appVersion = 'v1.0.01    '; // Versão do aplicativo